import React from 'react';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { Mechanism } from '../components/Mechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { ForWho } from '../components/ForWho';
import { Pricing } from '../components/Pricing';
import { Footer } from '../components/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function SalesPage() {
  // Initialize Meta Pixel and fire PageView on load
  useMetaPixel();
  return <div className="min-h-screen bg-[#FAF7F2] text-[#2D2A26] font-sans selection:bg-[#C4A35A] selection:text-white" data-id="element-175">
      <Hero data-id="element-176" />
      <PainSection data-id="element-177" />
      <FailedSolutions data-id="element-178" />
      <Mechanism data-id="element-179" />
      <WhatYouGet data-id="element-180" />
      <ForWho data-id="element-181" />
      <Pricing data-id="element-182" />
      <Footer data-id="element-183" />
    </div>;
}